import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { FileProgress } from '../../../hooks/useFileProcessing';
import { FileProgressCard } from './FileProgressCard';

interface FileProcessingModalProps {
    isVisible: boolean;
    currentPhase: string;
    currentFileProgress: FileProgress | null;
    currentFileIndex: number;
    totalFiles: number;
    isEditing?: boolean;
}

export const FileProcessingModal: React.FC<FileProcessingModalProps> = ({
    isVisible,
    currentPhase,
    currentFileProgress,
    currentFileIndex,
    totalFiles,
    isEditing = false
}) => {
    if (!isVisible) return null;

    return (
        <div className="absolute inset-0 z-10 flex items-center justify-center p-4 text-center pointer-events-none">
            <div className="bg-gray-100 p-6 rounded-lg shadow-lg pointer-events-auto max-w-lg w-full max-h-[80vh] overflow-y-auto transition-all duration-500 ease-in-out">
                <h2 className="text-jtc-very-dark-grey text-md font-semibold mb-2">
                    {isEditing ? 'Your assistant is being updated...' : 'Your assistant is being created...'}
                </h2>
                <p className="text-jtc-very-dark-grey text-sm mb-4">
                    {currentPhase || 'Processing...'}
                </p>

                <div
                    className={`flex justify-center transition-all duration-500 ease-in-out ${!currentFileProgress
                        ? 'max-h-[100px] opacity-100 mb-4'
                        : 'max-h-0 opacity-0 mb-0'
                        }`}
                >
                    {!currentFileProgress && (
                        <ClipLoader size={40} color="#E91E8C" />
                    )}
                </div>

                <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${currentFileProgress
                        ? 'max-h-[500px] opacity-100'
                        : 'max-h-0 opacity-0'
                        }`}
                >
                    {currentFileProgress && (
                        <div
                            key={`${currentFileProgress.filename}-${currentFileIndex}`}
                            className="text-left animate-fade-in"
                        >
                            <FileProgressCard progress={currentFileProgress} />
                        </div>
                    )}
                </div>

                <p className="text-jtc-very-dark-grey text-sm mt-4">
                    This may take a few minutes depending on the number and size of files submitted.
                    <br />
                    Please keep this window open.
                </p>
            </div>
        </div>
    );
};